import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { homeNode } from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import {
    UpdateNodeAsync
} from "source/app/services/Workflows/ChangeData/UpdateNodeAsync";
import { IWorkflowsState } from "../../../IWorkflowsState";
import { GetWorkflowsState } from "../../../Workflows";
import classNames from "classnames";

export function ToggleFavorite({
    rootNode,
    compact = false,
}: {
    rootNode: IWorkflowNode;
    compact?: boolean;
}) {
    const [isFavorite, setIsFavorite] = React.useState(rootNode.isfavorite);

    React.useEffect(() => {
        setIsFavorite(rootNode.isfavorite);
    }, [rootNode.id]);

    const containerStyleClass = StyleClass(
        `rootNodeFavoriteOptionContainer`,
        {
            alignItems: "center",
            color: "inherit",
            display: "inline-flex",
            fontSize: "11px",
            fontWeight: "normal",
            whiteSpace: "nowrap",
        }
    );

    const favoriteTextStyleClass = StyleClass(`favoriteNodeText`, {
        fontWeight: "bold",
    });

    if (rootNode.id === homeNode.id) {
        return null;
    }

    return (
        <span data-is-favorite={isFavorite}>
            <IconWithText
                iconSuffix={
                    isFavorite ? EGlyphicon.star : EGlyphicon["star-empty"]
                }
                whenClicked={async () => {
                    const newValue = !isFavorite;
                    setIsFavorite(newValue);
                    UpdateFavoritesStateLocally(rootNode, newValue);
                    try {
                        await UpdateNodeAsync(rootNode, {
                            isfavorite: newValue,
                        });
                    } catch (error) {
                        setIsFavorite(!newValue);
                        UpdateFavoritesStateLocally(rootNode, !newValue);
                        throw error;
                    }
                }}
                withClass={classNames(containerStyleClass, {
                    [favoriteTextStyleClass]: isFavorite,
                })}
                displayAsBlock={false}
            >
                {compact ? undefined : "Favorite"}
            </IconWithText>
        </span>
    );
}

function UpdateFavoritesStateLocally(
    rootNode: IWorkflowNode,
    newValue: boolean
) {
    const workflows = GetWorkflowsState();
    let newFavoriteNodes = [...workflows.state.favoriteNodes];

    newFavoriteNodes = newFavoriteNodes.filter(
        (node) => node.id !== rootNode.id
    );

    if (newValue) {
        newFavoriteNodes.unshift({ ...rootNode, isfavorite: true });
    }

    State.ReadClass<IWorkflowsState>(ESharedComponent.Workflows).setState({
        favoriteNodes: newFavoriteNodes,
    });
}
